<!--
  Sub Navigation

  @since 2018-07-25
  @author kdydesign.kim
-->

<template>
  <menu-slide-transition  @afterTransition="(() => deviceTabUlToggle = !deviceTabUlToggle)">
    <div v-show="isSubMenuOpen"
         class="navi-depth"
         :style="{width: subMenuWidth}">
      <div class="page-header-inner"></div>
      <div class="depth-group">
        <!-- 장비 유형 영역 -->
        <div class="device-sort-area"
             v-show="!disableDeviceTypeMenu"
             :class="{'device-active': !disableDeviceTypeMenu}"
        >
          <ul :class="{'open': deviceTabUlToggle}">
            <li v-for="deviceType in deviceTypeTabs"
                v-if="isShowDeviceTab(deviceType)"
                :key="deviceType"
                :class="{'on' : selectedDeviceTypeTab === deviceType}"
                @click="(() => selectedDeviceTypeTab = deviceType)">
              <span class="device-ico"></span>
              <span class="device-txt">{{deviceType}}</span>
            </li>
          </ul>
        </div>
        <!-- 서브 메뉴 영역 -->
        <div class="depth-align">
          <div v-show="!disableDeviceTypeMenu"
               class="device-title-area">{{selectedDeviceTypeTab}}</div>
          <!-- TAMS (menu -> deviceTypeMenu) -->
          <q-scroll-area v-for="(mainMenuItem, idx1) in deviceTypeMenu"
                         :key="mainMenuItem.key"
                         :class="[basicClass, {'on': subMenuKey === mainMenuItem.key}]"
          >
            <ul>
              <!-- Middle Menu -->
              <li v-for="(mdMenuItem, idx2) in mainMenuItem.children"
                  v-show="mdMenuItem.isUsed"
                  :key="`${mdMenuItem.key}_${idx2}`">
                <ul :class="getSubMenuIcon(mainMenuItem.key, mdMenuItem.key)">
                  <!-- Middle Title-->
                  <li
                    class="depth-ul-2depth-group-title"
                    @click="onFoldMenu(mdMenuItem)"
                  >
                    <a href="javascript: void 0;">
                     {{mdMenuItem.name}}
                      <!-- TAMS 제외 (추후) -->
                      <q-icon name="fa depth_ico_gnb_open"
                              class="depth-rotate"
                              :class="isOpen(mdMenuItem) ? 'rotate-180' : ''"
                      />
                    </a>

                  </li>
                  <transition name="depth-fold">
                    <ul v-show="isOpen(mdMenuItem)" style="padding-bottom: 20px">
                      <!-- Sub Menu -->
                      <li v-for="(depth3Menu, depth3Index) in mdMenuItem.children"
                          v-show="depth3Menu.isUsed"
                          :key="`${depth3Menu.key}_${depth3Index}`"
                          :class="depth3Menu.children ? 'depth-ul-3depth-li' : ''"
                          :style="getDepthAndSelectStyle(depth3Menu)"
                          @click="Array.isArray(depth3Menu.children) ? void 0 : subMenuHide()">

                        <!-- 4Depth Link(Log/Report 메뉴) -->
                        <template v-if="depth3Menu.children">
                          <a href="javascript:;"
                             style="position: relative !important;"
                             @click="onFoldMenu(depth3Menu)"
                          >
                            {{depth3Menu.name}}
                            <q-icon name="fa depth_ico_gnb_open" class="depth-rotate" :class="isOpen(depth3Menu) ? 'rotate-180' : ''"/>
                          </a>
                          <transition name="depth-fold">
                            <ul v-show="isOpen(depth3Menu)" :class="`depth-ul-3depth-group`">
                              <li v-for="(depth4Menu, depth4Index) in depth3Menu.children"
                                  v-show="depth4Menu.isUsed"
                                  :key="`${depth4Menu.key}_${depth4Index}`"
                                  :style="getDepthAndSelectStyle(depth4Menu)"
                                  @click="subMenuHide()"
                              >

                                <!-- TAMS (movePage)-->
                                <nuxt-link
                                  :to="getRouterLink(mainMenuItem, mdMenuItem, depth3Menu, depth4Menu)"
                                  :key="getRouterLink(mainMenuItem, mdMenuItem, depth3Menu, depth4Menu)"
                                  event=""
                                  @click.native.prevent="$emit('movePage', $event)"
                                  class="menu-cursor-pointer"
                                >
                                  {{depth4Menu.name}}
                                </nuxt-link>

                                <span v-show="depth4Menu.usePop"
                                      @click="onNewWindow(mainMenuItem, mdMenuItem, depth3Menu, depth4Menu)"
                                      class="navi-2dep-li-on"></span>

                              </li>
                            </ul>
                          </transition>
                        </template>

                        <!-- 3Depth Link(기본 메뉴) -->
                        <!-- TAMS (movePage) -->
                        <template v-else>
                          <nuxt-link
                            :to="getRouterLink(mainMenuItem, mdMenuItem, depth3Menu)"
                            :key="getRouterLink(mainMenuItem, mdMenuItem, depth3Menu)"
                            event=""
                            @click.native.prevent="$emit('movePage', $event)"
                            class="menu-cursor-pointer">
                            {{depth3Menu.name}}
                          </nuxt-link>

                          <span v-show="depth3Menu.usePop"
                                @click="onNewWindow(mainMenuItem, mdMenuItem, depth3Menu)"
                                class="navi-2dep-li-on"></span>
                        </template>
                      </li>
                    </ul>
                  </transition>
                </ul>
              </li>
            </ul>
          </q-scroll-area>
          <!-- Main Menu -->

          <!--Separator-->
          <ul class="depth-ul 2depth"></ul>

          <!--Client Sub Menu-->
          <q-scroll-area v-for="clientMenuItem in clientMenu"
                         :key="clientMenuItem.key"
                         :class="[basicClass, {'on': subMenuKey === clientMenuItem.key}]">
            <ul>
              <li>

                <template v-for="(item, idx) in clientMenuItem.children">
                <ul :class="['depth-ul-2depth-group', (item.key === 'help') ? 'ul-2depth-login-03' : 'ul-2depth-login-00']">
                  <li>
                    <a href="javascript:;"
                       class="menu-cursor-pointer"
                       v-html="$parent.getMenuName(item)"></a>
                  </li>
                </ul>
              </template>

<!--                <ul v-for="(item, idx) in clientMenuItem.children"-->
<!--                    :key="item.key"-->
<!--                    :class="getSubMenuIcon(clientMenuItem.key, item.key)">-->
<!--                  <li class="depth-ul-2depth-group-title" style="cursor: auto;">-->
<!--                    <a href="#" style="background-color: transparent;">{{item.name}}</a>-->
<!--                  </li>-->

<!--                  <template v-if="item.key === 'favorite'">-->
<!--                    <ul style="padding-bottom: 20px">-->
<!--                      <li :style="getDepthAndSelectStyle(item)"-->
<!--                        @click="subMenuHide()">-->
<!--                        <nuxt-link-->
<!--                          :to="`/${item.key}`"-->
<!--                          :key="`/${item.key}`"-->
<!--                          class="menu-cursor-pointer">-->
<!--                          {{$t('cmn.favoriteAddDel')}}-->
<!--                        </nuxt-link>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </template>-->

<!--                  <template v-else-if="item.key === 'favoriteList'">-->
<!--                    <ul style="padding-bottom: 20px">-->
<!--                      <li v-for="favoriteItem in item.children"-->
<!--                          :style="getDepthAndSelectStyle(favoriteItem)"-->
<!--                          @click="subMenuHide()">-->
<!--                        <nuxt-link-->
<!--                          class="menu-cursor-pointer"-->
<!--                          :to="favoriteItem.key"-->
<!--                          :key="favoriteItem.key">-->
<!--                          {{favoriteItem.name}}-->
<!--                        </nuxt-link>-->
<!--                        <span class="navi-2dep-li-on"-->
<!--                              v-show="favoriteItem.usePop"-->
<!--                              @click="onNewWindowByFavorite(favoriteItem)"></span>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </template>-->

<!--                  <template v-else-if="item.key === 'logout'">-->
<!--                    <li>-->
<!--                      <a href="#"-->
<!--                         class="menu-cursor-pointer"-->
<!--                         @click.prevent="$parent.$refs.confirmPopUp.show()"-->
<!--                         v-html="$parent.getMenuName(item)"></a>-->
<!--                    </li>-->
<!--                  </template>-->

<!--                  <template v-else>-->
<!--                    <li>-->
<!--                      <a href="#"-->
<!--                         class="menu-cursor-pointer"-->
<!--                         v-html="$parent.getMenuName(item)"></a>-->
<!--                    </li>-->
<!--                  </template>-->
<!--                </ul>-->

              </li>
            </ul>
          </q-scroll-area>
        </div>
      </div>
    </div>
  </menu-slide-transition>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  // transition component
  import MenuSlideTransition from '~/components/transition/MenuSlideTransition'

  // utils
  import {newWindow} from '~/utils/newWindow'

  // store helper
  const {mapState, mapGetters, mapActions} = createNamespacedHelpers('common/navigation')
  const authenticateHelper = createNamespacedHelpers('common/authenticate')
  const commonHelper = createNamespacedHelpers('common/common')

  // 2018.11.08 김민수 - 다국어 헬퍼 추가
  const localeHelper = createNamespacedHelpers('common/locale')

  // 분석 Store helper
  const analysisHelper = createNamespacedHelpers('analysis/profileAnalysis')

  const DEVICE_TYPE = {
    ALL: 0,
    NGF: 20,
    IPS: 21,
    WIPS: 22,
    ADS: 23
  }

  export default {
    name: 'SubNavigation',
    props: {
      isSubMenuOpen: {
        type: Boolean,
        default: false
      },
      subMenuKey: {
        type: String,
        default: void 0
      }
    },
    components: {
      MenuSlideTransition
    },
    data () {
      return {
        customStorageData: {},
        customMenuSettings: {},
        selectedDeviceTypeTab: 'ALL',
        deviceTypeTabs: ['ALL', 'NGF', 'IPS', 'ADS', 'WIPS'],
        deviceTabUlToggle: false
      }
    },
    computed: {
      ...mapState([
        'menu',
        // TAMS
        'menuFold'
      ]),
      ...mapGetters([
        'clientMenu'
      ]),
      ...localeHelper.mapGetters([
        'getCurrentLocale'
      ]),
      ...authenticateHelper.mapState([
        'authToken',
        'authIssueDate',
        'authRefreshToken'
      ]),
      ...commonHelper.mapState([
        'agentTime',
        'newWindows',
        'uiData'
      ]),
      ...analysisHelper.mapState([
        'profileDate'
      ]),
      // TAMS
      basicClass () {
        try {
          let res = 'bs bs-q-scroll-area bs-q-scroll-area-default depth-ul 2depth'

          if (this.disableDeviceTypeMenu) {
            res += ' bs-depth-ul-scroll-none-tab'
          } else {
            res += ' bs-depth-ul-scroll'
          }
          return res
        } catch (e) {
          return 'bs bs-q-scroll-area bs-q-scroll-area-default bs-depth-ul-scroll depth-ul 2depth'
        }
      },
      subMenuWidth () {
        // TAMS
        if (this.disableDeviceTypeMenu === true) {
          return (this.getCurrentLocale === 'en') ? '270px' : '230px'
        } else {
          if (this.subMenuKey === 'logReport') {
            return (this.getCurrentLocale === 'en') ? '380px' : '360px'
          }
          return (this.getCurrentLocale === 'en') ? '310px' : '270px'
        }
      },
      admId () {
        try {
          return String(this.$store.state.common.common.uiData.user.adm_id) || '0'
        } catch (e) {
          return '0'
        }
      },
      deviceTypeMenu () {
        try {
          if (this.selectedDeviceTypeTab !== 'ALL' && !this.disableDeviceTypeMenu) {
            const type = this.convertDeviceTypeTextToNumber(this.selectedDeviceTypeTab)
            return this.searchSupportDeviceMenu(type, this.menu)
          } else {
            return this.menu
          }
        } catch (e) {
          return []
        }
      },
      isTamsModel100 () {
        try {
          return String(this.$store.state.common.common.uiData.system_model) === 'BLUEMAX TAMS 100'
        } catch (e) {
          return false
        }
      },
      disableDeviceTypeMenu () {
        try {
          if (this.isTamsModel100 && this.subMenuKey === 'logReport') {
            return true
          }

          const supportDeviceTypeMenu = ['analysis', 'logReport', 'policyManagement']
          return !supportDeviceTypeMenu.includes(this.subMenuKey)
        } catch (e) {
          return false
        }
      }
    },
    methods: {
      ...mapActions([
        'reqMenuFold'
      ]),
      /**
       * 서브 메뉴에서 장비 유형 출력 여부
       *  - 분석 탭에서는 WIPS 제외 출력
       *  - CC 모드경우 Central Management 메뉴 내 WIPS 장비 탭 비노출
      **/
      isShowDeviceTab (deviceType) {
        if (['WIPS'].includes(deviceType) && this.subMenuKey === 'analysis') return false
        if (['WIPS'].includes(deviceType) && this.isCcMode && this.subMenuKey === 'policyManagement') return false
        return true
      },
      searchSupportDeviceMenu (type) {
        try {
          let menu = _.cloneDeep(this.menu)

          const finder = (t, m) => {
            if (_.size(m) > 0) {
              return _.filter(m, item => {
                if (_.get(item, ['children', 'length'], 0) > 0) {
                  item.children = finder(t, item.children)
                  return _.size(item.children) > 0
                } else {
                  if (_.get(item.deviceMenuType, ['length'], 0) > 0) {
                    return (
                      // item.deviceMenuType.indexOf(DEVICE_TYPE.ALL) !== -1 ||
                      item.deviceMenuType.indexOf(t) !== -1
                    )
                  }
                }
                return false
              })
            }
          }

          return finder(type, menu)
        } catch (e) {
          this.$log('[Sub Navigation GUI Error (searchSupportDeviceMenu)]', e)
          return []
        }
      },
      onNewWindow (fp, mp, lp, sp) {
        let name = ''
        let menuName = ''

        if (sp === void 0) {
          name = `${fp.key}-${mp.key}-${lp.key}`
          menuName = lp.name
        } else {
          name = `${fp.key}-${mp.key}-${lp.key}-${sp.key}`
          menuName = sp.name
        }

        let routeData = this.$router.resolve({
          name: name,
          query: {
            menuName: menuName,
            newWindow: true,
            deviceTime: this.agentTime
          }
        })

        newWindow({
          store: this.$store,
          url: routeData.href,
          props: {
            width: 1400,
            height: 950
          }
        })
      },
      onNewWindowByFavorite (menu) {
        let menuPath = menu.key.split('/')
        if (menuPath.length === 4) {
          this.onNewWindow({
            key: menuPath[1]
          }, {
            key: menuPath[2]
          }, {
            key: menuPath[3],
            name: menu.name
          })
        } else if (menuPath.length === 5) {
          this.onNewWindow({
            key: menuPath[1]
          }, {
            key: menuPath[2]
          }, {
            key: menuPath[3]
          }, {
            key: menuPath[4],
            name: menu.name
          })
        }
      },
      // TAMS
      getRouterLink (fp, mp, lp, sp) {
        const args = Array.prototype.slice.call(arguments)
        let link = ''
        let i
        for (i = 0; i < args.length; i++) {
          link += `/${args[i].key}`
        }
        if (typeof args[i - 1].children !== 'undefined') {
          link = ''
        }
        return link
      },
      getSubMenuIcon (key1, key2) {
        // return `depth-ul-2depth-group ul-2depth-${key1}-${key2}`
        let realKey1 = '', realKey2 = ''

        // TODO: 추후, 메뉴 URI 재정의 후 CSS명칭을 아예 변경할 것
        // 1-depth 예외처리
        switch (key1) {
          case 'prismSystem':
            realKey1 = 'system'
            break
          case 'analysis':
            realKey1 = 'threatAnalysis'
            break
          case 'docs':
            realKey1 = 'documents'
            break
          default:
            realKey1 = key1
        }

        // 2-depth 예외처리
        switch (key2) {
          case 'defs':
            realKey2 = 'documents'
            break
          default:
            realKey2 = key2
        }

        return `depth-ul-2depth-group ul-2depth--ps-${realKey1}-${realKey2}`
      },
      getDepthAndSelectStyle (item) {
        if (typeof item === 'undefined' || typeof item.route === 'undefined') {
          return
        }
        const vueRoutePath = this.$route.path.toLowerCase(),
          itemRoutePath = `/${item.route.toLowerCase()}`
        let style = ''

        if (vueRoutePath === itemRoutePath) {
          const lowerRoutePathArray = this.$route.path.toLowerCase().split('/')
          const lowerRoutePath1 = lowerRoutePathArray[lowerRoutePathArray.length - 2]
          const lowerRoutePath2 = lowerRoutePathArray[lowerRoutePathArray.length - 1]

          if (item.children) {
            style = {
              height: 'auto',
              padding: '0px'
            }
            if (lowerRoutePath1 === item.key.toLowerCase()) {
              style['background-color'] = '#c0daf2'
            }
          } else if (lowerRoutePath2 === item.key.toLowerCase()) {
            style = {
              'background-color': '#c0daf2'
            }
          }
          if (item.hasOwnProperty('gvRole') &&
              ((item.gvRole === 0 && item.key.indexOf('groupMember') > -1) ||
                  (item.gvRole === 1 && item.key.indexOf('groupServer') > -1))) {
            style = {
              'opacity': '0.5',
              'pointer-events': 'none !important'
            }
          }
        }

        return style
      },
      subMenuHide () {
        this.$emit('changeIsSubMenu', false)
      },
      onFoldMenu (item) {
        // if (!_.has(item, 'isOpen')) return
        // item.isOpen = !item.isOpen
        // this.reqMenuFold({key: item.key, isOpen: item.isOpen})

        // TAMS
        // if (typeof this.menuFold[item.code] === 'undefined') {
        //   this.menuFold[item.code] = {}
        // }
        // if (typeof this.menuFold[item.code].isOpen === 'undefined') {
        //   this.menuFold[item.code].isOpen = true
        // }
        // this.menuFold[item.code].isOpen = !this.menuFold[item.code].isOpen

        this.reqMenuFold({
          code: item.code.toString(),
          isOpen: !_.get(this.menuFold, [item.code, 'isOpen'], true)
        })
      },
      isOpen (item) {
        // if (!_.has(item, 'isOpen')) return true
        // return item.isOpen

        // TAMS
        if (typeof this.menuFold[item.code] === 'undefined') {
          this.menuFold[item.code] = {}
        }
        if (typeof this.menuFold[item.code].isOpen === 'undefined') {
          this.menuFold[item.code].isOpen = true
        }

        return this.menuFold[item.code].isOpen
      },
      convertDeviceTypeTextToNumber (type) {
        try {
          return DEVICE_TYPE[type]
        } catch (e) {
          return ''
        }
      }
    },
    watch: {
      subMenuKey (key) {
        // 메뉴 항목에 해당 장비 항목이 없을 경우 ALL로 변경
        if (this.selectedDeviceTypeTab === 'WIPS') {
          if (key === 'analysis' || (this.isCcMode && key === 'policyManagement')) {
            this.selectedDeviceTypeTab = 'ALL'
          }
        }
        if (this.selectedDeviceTypeTab === 'ADS' && key === 'analysis') {
          this.selectedDeviceTypeTab = 'ALL'
        }
      }
    }
  }
</script>
